import { render } from "./buyList.vue?vue&type=template&id=bbc9a62a&scoped=true"
import script from "./buyList.vue?vue&type=script&lang=js"
export * from "./buyList.vue?vue&type=script&lang=js"

import "./buyList.vue?vue&type=style&index=0&id=bbc9a62a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc9a62a"]])

export default __exports__